// import React, { useEffect, useState } from "react";
// import { Typography, Spin } from 'antd';
// import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
// const { Title } = Typography;

// const ConsumerInsightsReports = () => {
//     const [loading, setLoading] = useState(false);

//     useEffect(() => {
//         setLoading(false);
//     }, []);

//     return (
//         <Spin spinning={loading}>
//             <SidebarLayoutConsumer>
//                 <div style={{ marginRight: "18px" }}>
//                     <Title level={3} style={{ margin: "0 0 20px 0" }}>
//                         Insights
//                     </Title>
//                     <div
//                         style={{
//                             height: 'calc(80vh - 100px)',
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             textAlign: 'center',
//                             padding: 24,
//                         }}
//                     >
//                         <div>
//                             <Title level={2} style={{ marginBottom: 8 }}>
//                                 Coming Soon
//                             </Title>
//                         </div>
//                     </div>
//                 </div>
//             </SidebarLayoutConsumer>
//         </Spin>
//     );
// };

// export default ConsumerInsightsReports;


import React, { useEffect, useState } from "react";
import { Typography, Spin } from "antd";
import SidebarLayoutConsumer from "../Administrator/SidebarLayoutConsumer";
//import EchoChat from "../components/EchoChat"; // ✅ IMPORT LIKE OTHERS
import EchoChat from "./EchoChat";

const { Title } = Typography;

const ConsumerInsightsReports = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <Spin spinning={loading}>
      <SidebarLayoutConsumer>
        <div>
          {/* <Title level={3} style={{ margin: "0 0 20px 0" }}>
            Insights
          </Title> */}

          {/* Reused component */}
          <EchoChat />
        </div>
      </SidebarLayoutConsumer>
    </Spin>
  );
};

export default ConsumerInsightsReports;
